import _ from "lodash";
import { getRelativePath } from "Utils";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import OrgAddOn from "./routes/OrgAddOn";
export default store => ({
  path: "addOnManager",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-tooling" */ "./AddOnManager"
        ),
        import(
          /* webpackChunkName: "administrator-tooling" */ "./modules/AddOnManagerModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "addOnManager",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter: (nextState, replace) => {
    if (_.last(nextState.routes).path == "addOnManager") {
      replace(getRelativePath("../"));
    }
  },
  childRoutes: [OrgAddOn(store)],
});
